import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  stars: number;
  comment: string;
  image: string;
}
const testimonials: Testimonial[] = [{
  name: 'Ana Laura',
  location: 'Buenos Aires',
  stars: 5,
  comment: 'Este recetario cambió mi vida. Mis hijos ahora comen verduras sin protestar y yo me siento con mucha más energía.',
  image: 'https://randomuser.me/api/portraits/women/32.jpg'
}, {
  name: 'Marta',
  location: 'Córdoba',
  stars: 5,
  comment: 'La guía de fermentos es oro puro. Nunca pensé que fuera tan fácil hacer mi propio chucrut y kéfir en casa.',
  image: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Gabriela',
  location: 'Rosario',
  stars: 5,
  comment: 'Increíble la claridad de las explicaciones. Se nota que hay mucho amor y sabiduría en cada página.',
  image: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Lucía',
  location: 'Mendoza',
  stars: 5,
  comment: 'Gracias a los caldos de huesos mi inflamación desapareció por completo. Es un camino de ida a la salud real.',
  image: 'https://randomuser.me/api/portraits/women/22.jpg'
}, {
  name: 'Valentina',
  location: 'CABA',
  stars: 5,
  comment: 'El pan de masa madre es la estrella de mis desayunos ahora. No vuelvo a comprar pan industrial nunca más.',
  image: 'https://randomuser.me/api/portraits/women/33.jpg'
}];
export function TestimonialsSection() {
  const [visibleCount, setVisibleCount] = useState(3);
  const showMore = () => setVisibleCount(prev => Math.min(prev + 3, testimonials.length));
  const visibleTestimonials = testimonials.slice(0, visibleCount);
  const hasMore = visibleCount < testimonials.length;
  return <section className="py-24 px-4 bg-transparent relative z-10 pt-[20px] pb-[20px]" data-id="element-319">
      <div className="max-w-6xl mx-auto" data-id="element-320">
        <div className="text-center mb-16" data-id="element-321">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#8b7355]/10 border border-[#8b7355]/30 text-[#8b7355] text-sm font-black mb-6 tracking-widest" data-id="element-322">
            <StarIcon className="w-4 h-4 fill-[#8b7355]" data-id="element-323" />
            TESTIMONIOS REALES
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black text-[#0f1711] mb-6 tracking-tight leading-tight" data-id="element-324">
            LO QUE DICEN{' '}
            <span className="text-[#8b7355]" data-id="element-325">NUESTRAS ALUMNAS</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-[#3e2723]/70 max-w-2xl mx-auto font-medium" data-id="element-326">
            Más de 1,500 mujeres ya están transformando su salud con el
            Recetario Ancestral.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-327">
          {visibleTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-[#0f1711]/10 rounded-[2.5rem] p-8 hover:border-[#8b7355]/30 transition-all duration-500 shadow-sm" data-id="element-328">
              <div className="flex items-start justify-between mb-6" data-id="element-329">
                <div className="flex items-center gap-4" data-id="element-330">
                  <img src={testimonial.image} alt={testimonial.name} width={56} height={56} className="w-14 h-14 rounded-full object-cover border-2 border-[#8b7355]/30" loading="lazy" decoding="async" data-id="element-331" />
                  <div data-id="element-332">
                    <h3 className="font-black text-[#0f1711] text-lg" data-id="element-333">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-[#8b7355] font-bold" data-id="element-334">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
                <div className="flex gap-0.5" data-id="element-335">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < testimonial.stars ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-700 text-gray-700'}`} data-id="element-336" />)}
                </div>
              </div>
              <p className="text-[#3e2723]/80 text-lg leading-relaxed font-medium italic" data-id="element-337">
                "{testimonial.comment}"
              </p>
            </motion.div>)}
        </div>

        {hasMore && <div className="text-center" data-id="element-338">
            <button onClick={showMore} className="inline-flex items-center gap-3 px-10 py-4 bg-transparent border-2 border-[#8b7355] text-[#8b7355] hover:bg-[#8b7355] hover:text-white font-black rounded-2xl transition-all uppercase tracking-widest shadow-sm" data-id="element-339">
              Ver más testimonios
            </button>
          </div>}
      </div>
    </section>;
}